import { render, staticRenderFns } from "./ProgramCard.vue?vue&type=template&id=06cde4b7&scoped=true&lang=pug&"
import script from "./ProgramCard.vue?vue&type=script&lang=js&"
export * from "./ProgramCard.vue?vue&type=script&lang=js&"
import style0 from "./ProgramCard.vue?vue&type=style&index=0&id=06cde4b7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cde4b7",
  null
  
)

export default component.exports